import { getVapidPublicKey, subscribePush, unsubscribePush } from './api';

// VAPID-ключ приходит в urlsafe-base64, PushManager.subscribe ждёт Uint8Array
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const isPushSupported = () =>
  'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

// iOS/iPadOS Safari разрешает Notification.requestPermission() и push-подписку
// только когда сайт открыт как установленное на экран «Домой» приложение
export const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

export const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export const getNotificationPermission = () =>
  ('Notification' in window ? Notification.permission : 'unsupported');

export const getExistingSubscription = async () => {
  if (!isPushSupported()) return null;
  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.getSubscription();
};

export const subscribeToPush = async () => {
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Уведомления заблокированы в настройках браузера');
  }

  const registration = await navigator.serviceWorker.ready;
  const { publicKey } = await getVapidPublicKey();
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });

  const json = subscription.toJSON();
  await subscribePush({ endpoint: json.endpoint, keys: json.keys });
  return subscription;
};

export const unsubscribeFromPush = async () => {
  const subscription = await getExistingSubscription();
  if (!subscription) return;
  await unsubscribePush(subscription.endpoint);
  await subscription.unsubscribe();
};
